import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import CoverImage from "./CoverImage"
export default function Dashboard() {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [creator, setCreator] = useState(null);
  const [trips, setTrips] = useState([]);
  const [editTrip , setEditTrip]=useState(null);
  const [showEditModal , setShowEditModal]= useState(false);
  const [deleteTripId , setDeleteTripId] = useState(null);
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  // ✅ define first
  const fetchCreator = useCallback(async () => {
    try {
      const token =
        localStorage.getItem("token") ||
        sessionStorage.getItem("token");

      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/curator/me`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await res.json();
      setCreator(data);
    } catch (err) {
      console.error(err);
    }
  }, []);

  const checkStatus = useCallback(async () => {
    const token =
      localStorage.getItem("token") ||
      sessionStorage.getItem("token");

    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/api/curator/my-application`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );




    const data = await res.json();

    if (!data.applied) navigate("/curator/apply");
    else if (data.status !== "approved") navigate("/curator/profile");
    else setStatus("approved");

    setLoading(false);
  }, [navigate]);

  const fetchTrips = useCallback(async () => {
    try {
      const token =
        localStorage.getItem("token") ||
        sessionStorage.getItem("token");

      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/curated-trips/my-trips`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await res.json();
      setTrips(data);
    } catch (err) {
      console.error(err);
    }
  }, []);


const handleDelete = async (id) => {
  try {
    const token =
      localStorage.getItem("token") ||
      sessionStorage.getItem("token");

    await fetch(
      `${process.env.REACT_APP_API_URL}/api/curated-trips/${id}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setTrips((prev) => prev.filter((trip) => trip._id !== id));
  } catch (err) {
    console.error(err);
  }
};
  // ✅ THEN useEffect
  useEffect(() => {
    checkStatus();
    fetchCreator();
    fetchTrips();
  }, [checkStatus, fetchCreator, fetchTrips]);


  if (loading) return <div className="min-h-screen pt-24 text-center font-sans text-gray-500">Loading...</div>;
  if (status !== "approved") return null;

  const user = JSON.parse(localStorage.getItem("user"));
const handleUpdate = async () => {
  // ✅ basic validation
  if (!editTrip.title || !editTrip.city) {
    alert("Title and City are required");
    return;
  }

  if (!editTrip.itinerary?.days?.length) {
    alert("Add at least 1 day in itinerary");
    return;
  }

  try {
    setSaving(true); // 🔥 start loading

    const token =
      localStorage.getItem("token") ||
      sessionStorage.getItem("token");

    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/api/curated-trips/${editTrip._id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(editTrip),
      }
    );

    const updated = await res.json();

    // ✅ update UI instantly
    setTrips((prev) =>
      prev.map((t) => (t._id === updated._id ? updated : t))
    );

    setShowEditModal(false);
  } catch (err) {
    console.error(err);
  } finally {
    setSaving(false); // 🔥 stop loading
  }
};
  return (
    <div className="min-h-screen pt-24 pb-12 px-4 bg-[#f9fafb] font-sans">
      <div className="max-w-6xl mx-auto space-y-12">
        {/* HEADER */}
        <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-6 border-b border-gray-200/60 pb-8">
          <div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-[#1f2d1f] tracking-tight">
              Welcome back, {user?.name?.split(" ")[0]} <span className="inline-block animate-wave origin-bottom-right">👋</span>
            </h1>
            <p className="text-lg text-gray-500 mt-3 font-medium">
              Manage your curated travel experiences and monitor performance.
            </p>
          </div>

          <button
            onClick={() => navigate("/curator/create")}
            className="px-8 py-3.5 bg-[#5b6f00] text-white rounded-2xl font-bold shadow-lg shadow-[#5b6f00]/20 hover:shadow-xl hover:shadow-[#5b6f00]/30 hover:-translate-y-1 transition-all duration-300 w-full md:w-auto flex justify-center items-center gap-2"
          >
            <span className="text-xl">+</span> New Trip
          </button>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* CREATOR PROFILE CARD */}
          <div className="lg:col-span-2 bg-white p-8 md:p-10 rounded-[2rem] shadow-sm border border-gray-100 flex flex-col md:flex-row gap-8 items-start md:items-center relative overflow-hidden">
            {/* Subtle background decoration */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-[#5b6f00]/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none"></div>
            
            {/* LEFT */}
            <div className="flex items-center gap-6 flex-1 relative z-10 w-full">
              <div className="w-24 h-24 rounded-full overflow-hidden bg-gray-50 flex-shrink-0 border-[3px] border-white shadow-lg">
                {creator?.avatar ? (
                  <img
                    src={creator.avatar}
                    alt={creator.fullName}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-4xl font-bold text-[#5b6f00] bg-[#5b6f00]/10">
                    {creator?.fullName?.[0]}
                  </div>
                )}
              </div>

              <div>
                <h2 className="font-extrabold text-2xl text-[#1f2d1f] mb-2">
                  {creator?.fullName}
                </h2>
                <div className="flex flex-wrap items-center gap-3">
                  <span className="flex items-center gap-1.5 text-sm font-semibold text-gray-600 bg-gray-50 px-3 py-1.5 rounded-xl border border-gray-100">
                    <span className="opacity-70">📍</span> {creator?.location || "Global"}
                  </span>
                  <span className="px-3 py-1.5 bg-[#5b6f00]/5 text-[#5b6f00] text-xs font-bold rounded-xl border border-[#5b6f00]/10 uppercase tracking-wider">
                    {creator?.primaryPlatform || "Creator"}
                  </span>
                </div>
              </div>
            </div>

            {/* RIGHT STATS */}

            
            <div className="flex flex-row md:flex-col gap-4 w-full md:w-auto relative z-10">
              {creator?.youtube?.subscribers > 0 && (
                <div className="flex items-center gap-4 bg-gray-50 px-5 py-3 rounded-2xl border border-gray-100 w-full md:min-w-[200px]">
                  <div className="w-10 h-10 rounded-full bg-red-100 text-red-500 flex items-center justify-center text-lg">▶</div>
                  <div>
                    <p className="text-xl font-extrabold text-[#1f2d1f] leading-none mb-1">{creator.youtube.subscribers}</p>
                    <p className="text-xs text-gray-500 font-bold uppercase tracking-wider text-left">Subs</p>
                  </div>
                </div>
              )}
              {creator?.instagram?.followers > 0 && (
                <div className="flex items-center gap-4 bg-gray-50 px-5 py-3 rounded-2xl border border-gray-100 w-full md:min-w-[200px]">
                  <div className="w-10 h-10 rounded-full bg-pink-100 text-pink-500 flex items-center justify-center text-lg">📸</div>
                  <div>
                    <p className="text-xl font-extrabold text-[#1f2d1f] leading-none mb-1">{creator.instagram.followers}</p>
                    <p className="text-xs text-gray-500 font-bold uppercase tracking-wider text-left">Followers</p>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* CREATOR BIO / PITCH */}
          <div className="lg:col-span-1 bg-white p-8 rounded-[2rem] shadow-sm border border-gray-100 flex flex-col justify-center">
            <h2 className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-4 flex items-center gap-2">
              <span className="w-4 h-[1px] bg-gray-300"></span>
              About You
            </h2>
            <p className="text-gray-700 leading-relaxed font-medium mb-6">
              {creator?.pitch || "No bio added yet"}
            </p>
            <div className="flex gap-2 flex-wrap mt-auto">
              {creator?.contentStyle?.map((tag, i) => (
                <span
                  key={i}
                  className="px-3 py-1 text-xs font-bold bg-[#5b6f00]/5 text-[#5b6f00] rounded-lg border border-[#5b6f00]/10 tracking-wide"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* QUICK ACTIONS */}
        <div className="pt-4">
          <h2 className="text-2xl font-bold text-[#1f2d1f] mb-6 tracking-tight">Quick Actions</h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            <div
              onClick={() => navigate("/curator/create")}
              className="group bg-white p-8 rounded-[2rem] shadow-sm border border-gray-100 cursor-pointer hover:shadow-xl hover:-translate-y-1.5 transition-all duration-300 flex flex-col items-start relative overflow-hidden"
            >
              <div className="absolute top-0 right-0 p-6 opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-opacity translate-x-4 group-hover:translate-x-0 duration-300">
                <span className="text-[#5b6f00] text-xl font-bold">➔</span>
              </div>
              <div className="w-14 h-14 rounded-2xl bg-[#5b6f00]/10 text-[#5b6f00] flex items-center justify-center text-2xl mb-6 group-hover:scale-110 transition-transform shadow-inner">✍️</div>
              <p className="font-bold text-xl text-[#1f2d1f] mb-1">Create Trip</p>
              <p className="text-sm text-gray-500 font-medium">Design a new itinerary</p>
            </div>

            <div
              onClick={() => navigate("/explore")}
              className="group bg-white p-8 rounded-[2rem] shadow-sm border border-gray-100 cursor-pointer hover:shadow-xl hover:-translate-y-1.5 transition-all duration-300 flex flex-col items-start relative overflow-hidden"
            >
              <div className="absolute top-0 right-0 p-6 opacity-0 group-hover:opacity-100 transition-opacity translate-x-4 group-hover:translate-x-0 duration-300">
                <span className="text-blue-500 text-xl font-bold">➔</span>
              </div>
              <div className="w-14 h-14 rounded-2xl bg-blue-50 text-blue-500 flex items-center justify-center text-2xl mb-6 group-hover:scale-110 transition-transform shadow-inner">🌍</div>
              <p className="font-bold text-xl text-[#1f2d1f] mb-1">Explore</p>
              <p className="text-sm text-gray-500 font-medium">Discover other creators</p>
            </div>

            <div className="bg-gray-50 p-8 rounded-[2rem] border border-gray-200/80 cursor-not-allowed flex flex-col items-start relative">
              <div className="absolute top-6 right-6">
                <span className="bg-gray-200 text-gray-500 text-[10px] font-bold px-2 py-1 rounded-full uppercase tracking-widest">Soon</span>
              </div>
              <div className="w-14 h-14 rounded-2xl bg-white text-gray-400 flex items-center justify-center text-2xl mb-6 border border-gray-100 shadow-sm">📊</div>
              <p className="font-bold text-xl text-gray-400 mb-1">Analytics</p>
              <p className="text-sm text-gray-400 font-medium">Monitor performance</p>
            </div>
          </div>
        </div>

        {/* TRIPS SECTION */}
        <div className="pt-4">
          <div className="flex items-center justify-between mb-8">
            <h2 className="text-2xl font-bold text-[#1f2d1f] tracking-tight">Your Trips</h2>
            <span className="bg-white border border-gray-100 text-gray-600 px-4 py-1.5 rounded-full text-sm font-bold shadow-sm">{trips.length} Total</span>
          </div>

          {trips.length === 0 ? (
            <div className="bg-white p-16 rounded-[2rem] shadow-sm border border-gray-100 flex flex-col items-center justify-center text-center">
              <div className="w-24 h-24 bg-gray-50 rounded-full flex items-center justify-center text-4xl mb-6 shadow-sm border border-gray-100">✈️</div>
              <p className="text-2xl font-extrabold text-[#1f2d1f] mb-3">No trips published yet</p>
              <p className="text-gray-500 mb-8 max-w-md font-medium text-lg">Start creating your first curated travel experience to share with your audience.</p>
              <button
                onClick={() => navigate("/curator/create")}
                className="px-8 py-4 bg-[#1f2d1f] text-white rounded-2xl font-bold shadow-md hover:shadow-xl hover:bg-[#5b6f00] hover:-translate-y-1 transition-all duration-300"
              >
                Create your first trip
              </button>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              
              {trips.map((trip) => (
                <div
                  key={trip._id}
                  onClick={() => navigate(`/curated/${trip._id}`)}
                  className="group bg-white rounded-3xl shadow-sm border border-gray-100 cursor-pointer hover:shadow-xl hover:-translate-y-1.5 transition-all duration-300 overflow-hidden flex flex-col"
                >
                   {/* ✅ ADD BUTTONS HERE */}
                    <div className="absolute top-4 right-4 flex gap-2 z-10 opacity-0 group-hover:opacity-100 transition">
                      {/* EDIT */}
                      <button
                      onClick={(e) => {
                          e.stopPropagation();
                          setEditTrip(trip);
                          setShowEditModal(true);
                        }}
                        className="bg-white/90 backdrop-blur px-3 py-1.5 text-xs font-bold rounded-lg shadow hover:bg-[#5b6f00] hover:text-white transition"
                      >
                        ✏️
                      </button>

                      {/* DELETE */}
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                        setDeleteTripId(trip._id);
                        }}
                        className="bg-white/90 backdrop-blur px-3 py-1.5 text-xs font-bold rounded-lg shadow hover:bg-red-500 hover:text-white transition"
                      >
                        🗑
                      </button>
                    </div>
                  {/* 🖼 COVER IMAGE */}
                  <div className="h-48 w-full overflow-hidden relative">
                    <div className="absolute inset-0 group-hover:scale-105 transition-transform duration-700">
                      <CoverImage city={trip.city} />
                    </div>
                    {/* Dark gradient for text readability if we add text inside */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                  </div>

                  {/* CONTENT */}
                  <div className="p-6 flex flex-col flex-1">
                    {/* TOP META */}
                    <div className="flex items-center justify-between mb-3">
                      <span className="px-3 py-1 bg-gray-50 text-gray-600 border border-gray-100 text-xs font-bold uppercase tracking-wider rounded-lg">
                        📍 {trip.city}
                      </span>
                      {trip.duration && (
                        <span className="text-xs font-bold text-gray-400 uppercase tracking-widest">
                          {trip.duration} days
                        </span>
                      )}
                    </div>

                    {/* TITLE */}
                    <h3 className="font-extrabold text-xl text-[#1f2d1f] group-hover:text-[#5b6f00] transition-colors leading-tight line-clamp-2 mb-3">
                      {trip.title}
                    </h3>

                    {/* DESCRIPTION */}
                    {trip.description && (
                      <p className="text-sm text-gray-500 line-clamp-2 leading-relaxed font-medium">
                        {trip.description}
                      </p>
                    )}

                    {/* FOOTER CTA */}
                    <div className="mt-auto pt-5 flex items-center justify-start border-t border-gray-50">
                      <span className="text-[#5b6f00] font-bold flex items-center gap-2 group-hover:gap-3 transition-all text-sm">
                        View trip <span>➔</span>
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

      </div>

  {showEditModal && editTrip && (
  <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-sm p-4 overflow-y-auto">
    
    <div className="bg-white w-full max-w-3xl rounded-3xl shadow-2xl p-6 md:p-8 relative animate-fadeIn max-h-[90vh] overflow-y-auto">

      {/* CLOSE */}
      <button
        onClick={() => setShowEditModal(false)}
        className="absolute top-4 right-4 text-gray-400 hover:text-black text-xl"
      >
        ✕
      </button>

      <h2 className="text-2xl font-bold mb-6 text-[#1f2d1f]">
        Edit Trip
      </h2>

      {/* ================= BASIC ================= */}
      <div className="space-y-4">

        <input
          value={editTrip.title}
          onChange={(e) =>
            setEditTrip({ ...editTrip, title: e.target.value })
          }
          className="w-full border rounded-xl px-4 py-3"
          placeholder="Title"
        />

        <input
          value={editTrip.city}
          onChange={(e) =>
            setEditTrip({ ...editTrip, city: e.target.value })
          }
          className="w-full border rounded-xl px-4 py-3"
          placeholder="City"
        />

        <textarea
          value={editTrip.description}
          onChange={(e) =>
            setEditTrip({ ...editTrip, description: e.target.value })
          }
          className="w-full border rounded-xl px-4 py-3"
          placeholder="Description"
          rows={3}
        />

        <div className="grid grid-cols-2 gap-4">
          <input
            type="number"
            value={editTrip.duration}
            onChange={(e) =>
              setEditTrip({ ...editTrip, duration: Number(e.target.value) })
            }
            className="border rounded-xl px-4 py-3"
            placeholder="Duration"
          />

          <input
            type="number"
            value={editTrip.budget || ""}
            onChange={(e) =>
              setEditTrip({ ...editTrip, budget: Number(e.target.value) })
            }
            className="border rounded-xl px-4 py-3"
            placeholder="Budget"
          />
        </div>

        <input
          value={editTrip.bestTime || ""}
          onChange={(e) =>
            setEditTrip({ ...editTrip, bestTime: e.target.value })
          }
          className="w-full border rounded-xl px-4 py-3"
          placeholder="Best Time"
        />

        <input
          value={editTrip.stay || ""}
          onChange={(e) =>
            setEditTrip({ ...editTrip, stay: e.target.value })
          }
          className="w-full border rounded-xl px-4 py-3"
          placeholder="Stay (hotel, hostel, etc)"
        />

      </div>

      {/* ================= TAGS ================= */}
      <div className="mt-6">
        <h3 className="font-bold mb-2">Tags (comma separated)</h3>
        <input
          value={(editTrip.tags || []).join(", ")}
          onChange={(e) =>
            setEditTrip({
              ...editTrip,
              tags: e.target.value.split(",").map(t => t.trim())
            })
          }
          className="w-full border px-4 py-3 rounded-xl"
        />
      </div>

      {/* ================= HIGHLIGHTS ================= */}
      <div className="mt-6">
        <h3 className="font-bold mb-2">Highlights</h3>
        <textarea
          value={(editTrip.highlights || []).join("\n")}
          onChange={(e) =>
            setEditTrip({
              ...editTrip,
              highlights: e.target.value.split("\n")
            })
          }
          className="w-full border px-4 py-3 rounded-xl"
          rows={3}
        />
      </div>

      {/* ================= RECOMMENDATIONS ================= */}
      <div className="mt-6">
        <h3 className="font-bold mb-2">Recommendations</h3>
        <textarea
          value={(editTrip.recommendations || []).join("\n")}
          onChange={(e) =>
            setEditTrip({
              ...editTrip,
              recommendations: e.target.value.split("\n")
            })
          }
          className="w-full border px-4 py-3 rounded-xl"
          rows={3}
        />
      </div>

      {/* ================= THINGS TO AVOID ================= */}
      <div className="mt-6">
        <h3 className="font-bold mb-2">Things to Avoid</h3>
        <textarea
          value={(editTrip.thingsToAvoid || []).join("\n")}
          onChange={(e) =>
            setEditTrip({
              ...editTrip,
              thingsToAvoid: e.target.value.split("\n")
            })
          }
          className="w-full border px-4 py-3 rounded-xl"
          rows={3}
        />
      </div>

      {/* ================= ITINERARY ================= */}
     <div className="mt-8">
  <h3 className="font-bold text-lg mb-4">Itinerary</h3>

  {editTrip?.itinerary?.days?.map((day, index) => (
    <div key={index} className="mb-5 border p-4 rounded-xl bg-gray-50">

      {/* DAY NUMBER */}
      <input
        type="number"
        value={day.day || index + 1}
        onChange={(e) => {
          const updatedDays = [...editTrip.itinerary.days];
          updatedDays[index].day = Number(e.target.value);

          setEditTrip({
            ...editTrip,
            itinerary: { ...editTrip.itinerary, days: updatedDays }
          });
        }}
        className="w-full border px-3 py-2 rounded mb-2"
        placeholder="Day Number"
      />

      {/* MORNING */}
      <input
        value={day.morning || ""}
        onChange={(e) => {
          const updatedDays = [...editTrip.itinerary.days];
          updatedDays[index].morning = e.target.value;

          setEditTrip({
            ...editTrip,
            itinerary: { ...editTrip.itinerary, days: updatedDays }
          });
        }}
        className="w-full border px-3 py-2 rounded mb-2"
        placeholder="🌅 Morning plan"
      />

      {/* AFTERNOON */}
      <input
        value={day.afternoon || ""}
        onChange={(e) => {
          const updatedDays = [...editTrip.itinerary.days];
          updatedDays[index].afternoon = e.target.value;

          setEditTrip({
            ...editTrip,
            itinerary: { ...editTrip.itinerary, days: updatedDays }
          });
        }}
        className="w-full border px-3 py-2 rounded mb-2"
        placeholder="☀️ Afternoon plan"
      />

      {/* EVENING */}
      <input
        value={day.evening || ""}
        onChange={(e) => {
          const updatedDays = [...editTrip.itinerary.days];
          updatedDays[index].evening = e.target.value;

          setEditTrip({
            ...editTrip,
            itinerary: { ...editTrip.itinerary, days: updatedDays }
          });
        }}
        className="w-full border px-3 py-2 rounded mb-2"
        placeholder="🌙 Evening plan"
      />

      {/* TIPS */}
      <textarea
        value={day.tips || ""}
        onChange={(e) => {
          const updatedDays = [...editTrip.itinerary.days];
          updatedDays[index].tips = e.target.value;

          setEditTrip({
            ...editTrip,
            itinerary: { ...editTrip.itinerary, days: updatedDays }
          });
        }}
        className="w-full border px-3 py-2 rounded"
        placeholder="💡 Tips / Notes"
      />

      {/* REMOVE DAY */}
      <button
        onClick={() => {
          const updatedDays = editTrip.itinerary.days.filter((_, i) => i !== index);

          setEditTrip({
            ...editTrip,
            itinerary: { ...editTrip.itinerary, days: updatedDays }
          });
        }}
        className="mt-3 text-red-500 text-sm font-medium"
      >
        Remove Day
      </button>
    </div>
  ))}

  {/* ADD DAY */}
  <button
    onClick={() => {
      const newDay = {
        day: (editTrip?.itinerary?.days?.length || 0) + 1,
        morning: "",
        afternoon: "",
        evening: "",
        tips: "",
      };

      setEditTrip({
        ...editTrip,
        itinerary: {
          ...editTrip.itinerary,
          days: [...(editTrip.itinerary?.days || []), newDay],
        },
      });
    }}
    className="mt-3 px-5 py-2 bg-[#5b6f00] text-white rounded-lg font-bold"
  >
    + Add Day
  </button>
</div>

      {/* ================= ACTIONS ================= */}
      <div className="flex justify-end gap-3 mt-8">
        <button
          onClick={() => setShowEditModal(false)}
          className="px-5 py-2 rounded-xl border"
        >
          Cancel
        </button>

        <button
            onClick={handleUpdate}
            disabled={saving}
            className={`px-6 py-2 rounded-xl font-bold text-white transition ${
              saving
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-[#5b6f00] hover:bg-[#4a5a00]"
            }`}
          >
            {saving ? (
                <span className="flex items-center gap-2">
                  <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                  Saving...
                </span>
              ) : (
                "Save Changes"
              )}
          </button>
      </div>

    </div>
  </div>
)}

{deleteTripId && (
  <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-sm p-4">

    <div className="bg-white w-full max-w-md rounded-3xl shadow-2xl p-6 text-center animate-fadeIn">

      {/* ICON */}
      <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-red-100 flex items-center justify-center text-2xl">
        🗑
      </div>

      {/* TITLE */}
      <h2 className="text-xl font-bold text-[#1f2d1f] mb-2">
        Delete this trip?
      </h2>

      {/* DESCRIPTION */}
      <p className="text-gray-500 mb-6">
        This action is permanent and cannot be undone.
      </p>

      {/* ACTIONS */}
      <div className="flex justify-center gap-4">

        <button
          onClick={() => setDeleteTripId(null)}
          className="px-5 py-2 border rounded-xl"
        >
          Cancel
        </button>

        <button
          onClick={async () => {
            await handleDelete(deleteTripId);
            setDeleteTripId(null);
          }}
          className="px-5 py-2 bg-red-500 text-white rounded-xl font-bold hover:bg-red-600 transition"
        >
          Delete Forever
        </button>

      </div>

    </div>
  </div>
)}
    </div>
  );

 
}